
export default {
  props: {
    title: {type: String, required: true},
    completed: {type: Boolean, default: false},
    open: {type: Boolean, default: false}
  }
}
